import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import classNames from 'classnames'
import Category from './Category'
import { ModelCategory } from '../../../types/faq/faq_model'
import { FormattedMessage } from 'react-intl'
import { useMediaQuery } from 'react-responsive'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		faqStyleLargeScreen: {
			textAlign: 'start',
			paddingTop: '84px',
			paddingBottom: '111px',
			paddingLeft: '45px',
			paddingRight: '45px'
		},
		faqStyleSmallScreen: {
			textAlign: 'start',
			paddingTop: '42px',
			paddingBottom: '55px',
			paddingLeft: '22px',
			paddingRight: '22px'
		},
		textNotFound: {
			color: theme.palette.blue.main,
			display: 'flex',
			justifyContent: 'center',
			textAlign: 'center'
		}
	}
))

interface AcceptingProps {
	categories: Array<ModelCategory>,
	expandDefault: boolean,
	isEmpty: (cat: Array<ModelCategory>) => boolean
}

type FaqBodyProps = AcceptingProps

const FaqBody: React.FC<FaqBodyProps> = (
	{
		categories,
		expandDefault,
		isEmpty
	}
) => {
	const classes = useStyle()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const faqBodyStyle = classNames(
		isLargeScreen ? [classes.faqStyleLargeScreen] : [classes.faqStyleSmallScreen],
		classes.backgroundWhite
	)

	const textNotFoundClass = classNames(
		classes.title3,
		classes.textNotFound
	)

	return (
		<div className={faqBodyStyle}>
			{
				isEmpty(categories) ?
					<span className={textNotFoundClass}>
	                    <FormattedMessage
		                    id="faq.searchEmpty"
		                    defaultMessage="Aucune question ne correspond à votre recherche"
		                    description="Faq search no result"
	                    />
	                </span>
					:
					categories.map(
						(category: ModelCategory, key) =>
							category.themes && category.themes.length > 0 &&
							<Category key={key}
							          name={category.name}
							          themes={category.themes}
							          icon={category.icon}
							          expandDefault={expandDefault}
							/>
					)
			}
		</div>
	)
}

export default FaqBody
